import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { tokens } from '@treams/treams-ui';

const Title = styled(Box)`
	font-weight: bold;
	font-size: 16px;
`;

const StepTitle = styled(Box)<{ completed: boolean }>`
	${(props) =>
		props.completed
			? `color: ${props.theme.colors.green}; text-decoration: line-through;`
			: `color: ${tokens.text.secondary};`}
`;

const StepStatus = styled(Box)<{ completed: boolean }>`
	${(props) =>
		props.completed ? `color: ${props.theme.colors.green};` : `color: ${tokens.text.secondary};`}
`;

function CycleMomentStep({ title, completed }: { title: string; completed: boolean }) {
	const { t } = useTranslation();

	return (
		<Flex py={1}>
			<StepTitle flexGrow={1} flexShrink={1} completed={completed}>
				{title}
			</StepTitle>
			<StepStatus completed={completed}>
				{completed
					? t('cycle.moment.preview.status.completed')
					: t('cycle.moment.preview.status.pending')}
			</StepStatus>
		</Flex>
	);
}

export default function CycleMomentStatus({ instance }: { instance: graphql.MomentInstance }) {
	const { t } = useTranslation();

	if (instance.momentTemplate.type !== graphql.MomentType.Evaluation) {
		return null;
	}

	const party = instance.evaluation?.employee ?? instance.evaluation?.viewer;
	const hasShared = party?.status === graphql.EvaluationSubmissionStatus.Shared;
	const hasSigned = party?.status === graphql.EvaluationSubmissionStatus.Signed;
	const requiresSignature = party?.requiresSignature;

	return (
		<Box>
			<Title>{t('inbox.cycles.moments.status.title')}</Title>
			<CycleMomentStep
				title={t('inbox.cycles.moments.status.evaluations.start')}
				completed={!!instance.evaluation}
			/>
			<CycleMomentStep
				title={t('inbox.cycles.moments.status.evaluations.share')}
				completed={hasShared || hasSigned}
			/>
			{requiresSignature && (
				<CycleMomentStep
					title={t('inbox.cycles.moments.status.evaluations.confirm')}
					completed={hasSigned}
				/>
			)}
		</Box>
	);
}
